import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik,FieldArray } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import {  IoIosReturnLeft } from "react-icons/io";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { IoReturnDownForward } from "react-icons/io5";

import { PiNotePencilDuotone } from "react-icons/pi";
import { Container, Row, Col, Nav, Button, Modal } from 'react-bootstrap';
import { RiUserFollowLine } from "react-icons/ri";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";
import autoTable from "jspdf-autotable";
import KpiService from "../../Services/KpiService";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, allowNumberswithMaxLengthtypeOnly, currentDate, exportToentryExcel, exportToExcel, generateentryPdf, generatePdf, isValidtwo } from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Link } from "@mui/material";
// import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
// import * as XLSX from 'sheetjs-style';
import * as XLSX from 'xlsx';

import { FaPlusSquare } from "react-icons/fa";
import { FaSquareMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
export default function NewIndicatorEntry() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [hoveredRow, setHoveredRow] = useState(null);
const[showModal,setshowModal] = useState(false);
  const [distEnb, setDistEnb] = useState(false);
  const [Mandalenb, setMandalenb] = useState(false);
  const [distlist, setDistrictList] = useState();
  const [mandallist, setMandalList] = useState();
  const [Periodicitylist, setPeriodicitylist] = useState();
  const [Yearlist, setYearlist] = useState();
  const [Categorylist, setCategorylist] = useState();
  const [workFlow, setworkFlow] = useState([])
  const [currentstatus, setCurrentstatus] = useState("")
  const [Id, setId] = useState()
  const [Periodicid, setperiodicId] = useState()
  const [EntryData, setEntrydata] = useState()
  const [entrydataEnb, setEntrydataEnb] = useState(false)
  const [sequenceId, setSequenceid] = useState()
  const [Roleeid, setRoleeid] = useState()
  const [addModal, setAddModal] = useState();
  const [addModal1, setAddModal1] = useState();
  const [mandalId, setmandalId] = useState();
  const [distId, setDistId] = useState();
  const [searchText, setSearch] = useState("");
  const [CpoTableenb, setCpoTableenb] = useState(false);
  const [savedind, setsavedind] = useState([]);
  const [MandalCpo, setMandalCpo] = useState();
  const [Year, setYear] = useState();
  const [HeadId, setHeadId] = useState();
  const [fieldenb, setfieldenb] = useState(false);
  const [statusId, setstatusId] = useState()

  const[enb,setenb] =useState(false);
  const[index,setIndex] =useState(false);

  const [Secretariatlist, setSecretariatlist] = useState([]); 
  const [unitlist, setunitlist] = useState([]); 
  const [unitslist, setunitslist] = useState([]); 
  const [Deptlist, setDeptlist] = useState([]); 
  const [Deptslist, setDeptslist] = useState([]); 

  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");
  let mandal = localStorage.getItem("mandalid")
  let deptId = localStorage.getItem("deptid")
  let deptName = localStorage.getItem("deptName")
  let SectariatName = localStorage.getItem("SectariatName")

  const handleClose = () => {
    setAddModal(false);
};
  const formik = useFormik({
    initialValues: {
      userId: "",
      secretariat_name:"",
      department_id:"",
      periodic_id:"",
      unit:"",
      entry_type:"",
         indicator_name: "",
         formula:"" ,
         multiplier:"",
         divider:""
    },
    onSubmit: (values) => {
    }
  })
  

 





  const handleKeyDown = (e) => {
    // Prevent closing the modal on Enter or Escape keys
    if (e.key === 'Enter' || e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
    }
  };
 

  useEffect(() => {
    let params={
        userId:username
      }
    KpiService.secretariatMasterData(params).then((res17) => {
      if (res17.data) {
        let options = res17.data.SDESC?.map((item, i) => {
          return (
            <option key={i} value={item.secretariat_code}>
              {item.secretariat_name}
            </option>
          );
        });
        setSecretariatlist(options);
      }
    });
    
    
    KpiService.hodMasterData(params).then((res) => {
            if (res.data) { 
              setDeptslist(res.data?.SDESC);
              let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.deptcode}> {item.dept_name} </option> ); }); setDeptlist(options); }
          });
        
    
    KpiService.periodicitymaster(params).then((res20) => {
      if (res20.data) {
        let options = res20.data.SDESC.map((item, i) => {
          return (
            <option key={i} value={item.periodic_id}>
              {item.periodic_name}
            </option>
          );
        });
        setPeriodicitylist(options);
      }
    })
    KpiService.unitMasterData(params).then((res20) => {
        if (res20.data) {
          setunitslist(res20.data.SDESC)
          let options = res20.data.SDESC.map((item, i) => {
            return (
              <option key={i} value={item.unit_id}>
                {item.unit_name}
              </option>
            );
          });
          setunitlist(options);
        }
      })
  }, []);
 

  useEffect(() => {
    const handleScroll = () => {
      ReactTooltip.hide();
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  

  const allowAlphaNumeric = (e) => {
    const input = e.target;
    const value = input.value;
    const key = e.key;


    const regex = /^[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]*$/;


    if (input.selectionStart === 0 && input.selectionEnd === value.length) {
        if (!regex.test(key)) {
            e.preventDefault();
        }
    } else {
        if (!regex.test(value + key)) {
            e.preventDefault();
        }
    }
};

const AddIndicator=()=>{
    let missingFields = [];
    if (!formik.values.indicator_name) missingFields.push("Indicator Name");
    if (!formik.values.unit) missingFields.push("Unit");
    if (!formik.values.formula) missingFields.push("Formula");
    if (!formik.values.periodic_id) missingFields.push("Periodicity")
      if (!formik.values.entry_type) missingFields.push("Entry Type")

      if(missingFields.length > 0){
    const errorMessage = `Please Select Required Field ${missingFields.join(",")}.`;
    showAlertMessage(errorMessage, "warning");
    return;
    }
    const filterdeptid=Deptslist.filter(item=>item.deptcode === formik.values.department_id)[0]?.dept_id;
    // const deptid=filterdeptid[0]?.dept_id
    const unitCatId=unitslist.filter(item=>item.unit_id === parseInt(formik.values.unit))[0]?.unit_cat_id;
    let params={
      "userId": username,
      "deptId": filterdeptid,
      "secId": formik.values.secretariat_name,
      "hodId": formik.values.department_id,
      "indicatorName":formik.values.indicator_name,
      "unit": formik.values.unit,
      "periodicity_id": formik.values.periodic_id,
      "mandal": formik.values.entry_type === "mandal" ? "Yes":"No",
      "district": formik.values.entry_type === "district" ? "Yes":"No",
      "state": formik.values.entry_type === "state" ? "Yes":"No",
      "secretariat": formik.values.entry_type === "secretariat" ? "Yes":"No",
      "calFormula": formik.values.formula,
      "multiplir": formik.values.multiplier,
      "devider": formik.values.divider,
      "unitCatId": unitCatId
    }
    KpiService.newIndicatorsAdd(params).then((res1) => {
        if (res1.data && res1.data.SCODE === "01") {
           showAlertMessage(res1.data.SDESC,"success",()=>{
            setAddModal(false);
            fetchIndicatorsList(formik.values.department_id);
           })
            
          } 
        else{
            showAlertMessage(res1.data.SDESC,"warning")
        }
        
      });
      formik.setValues({
        ...formik.values, // keep other values intact
        periodic_id: "",
        unit: "",
        entry_type: "",
        indicator_name: "",
        formula: "",
        multiplier: "",
        divider: ""
      });
      
     

}
  const filteredData = searchText.length > 0 ? savedind?.filter((item) => {
    return (
      item &&
      Object.keys(item).some((key) => {
        const value = item[key];
        return (
          value !== null &&
          value
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      })
    );
  }) : savedind;



  const fetchIndicatorsList = (val) => {
    let params={
      "userId":username,
    "secId":formik.values.secretariat_name,
    "hodId":val,
    }
    KpiService.savedIndicatorsList(params).then((res) => {
      if (res.data.SCODE === "01") {
        setsavedind(res.data.SDESC)
     
      }
      else{
        showAlertMessage(res.data.SDESC,"warning");
      }
    });
  };



  return (
    <>
      <Menubar />

      <Container fluid style={{width:"90%"}} className='map-header'>
        <div className="sa-title">
         <h2>Indicator <span> Master</span></h2>
        </div>
      </Container>
  {/* <Container className='map-header'>
                <div className='sa-title'>
                <h2>Indicator <span> Master</span></h2>
                </div>
            </Container> */}

      <Container fluid style={{width:"90%"}}className='mt-3'>
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4'>
              <Row>
             
                           <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> Secretariat Name</label>
                            
                                           <Field component="select" name="secretariat_name" className="mb-3 form-control" onChange ={(e)=>{formik.handleChange(e)}}
                                            style={{ fontWeight: "bold" }} 
                                          
                                            >
                                                 <option value="">--Select--</option> {Secretariatlist} </Field> 
                                              
                           </Col>
                           <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> HOD Name</label>
                           
                                           <Field component="select" name="department_id" className="mb-3 form-control" onChange ={(e)=>{fetchIndicatorsList(e.target.value);formik.handleChange(e)}}
                                            style={{ fontWeight: "bold" }}  
                                            >
                                                 <option value="">--Select--</option> {Deptlist} </Field> 
                                               
          
                          
                           </Col>
              </Row>
            </div>
            <Container fluid  className="outer-page-content-container">
            
                            <Row>
                                <Col xs={12} sm={12} md={3} lg={4} xl={4} xxl={4} className=" mb-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text group_txt11" id="btnGroupAddon"><AiOutlineSearch /></div></div>
                                        <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch(event.target.value)} />
                                    </div>
                                </Col>
                                <Col className=" mb-2 " >
                                    <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "Indicator list",10)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    {/* <button className="btn  btn-sm mx-2 excel-btn" style={{ float: "right", marginLeft: "3px" }} >    <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="Indicator List" sheet="tablexls" buttonText={<span style={{ color: "green" }}>Excel  <AiFillFileExcel style={{ fontSize: "18px" }} /> </span>}></ReactHTMLTableToExcel></button> */}
                                    <button
                              variant="success"
                              size="sm"
                              className="btn mx-2 excel-btn"
                              style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                              onClick={() => exportToExcel("my-table", "Indicator List")}
                            >
                              Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                            </button>
                                    {/* {roleid === "5" || roleid === "8" ? */}
                                        <div className="mb-1  d-flex justify-content-end" >
                                            <button type="submit" className="btn btn-success btn-sm target-btn1 " onClick={(e) => { setAddModal(true) }} ><FaPlus /> Add New Indicator/Activity</button>
                                        </div>
                                        {/* : null} */}
                                </Col>
                            </Row>
                            <div id="table-scroll" className="table-scroll table-wrap">
                            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered sticky-table">
                                    <thead >
                                        <tr className="text-center">
                                            <th className="sticky-col sticky-sno">Sl.No.</th>
                                            <th className="sticky-col sticky-mandal">Indicator Name</th>
                                            <th>Unit</th>
                                            <th>Entry Level - Formula</th>
                                            <th>Formula</th>
                                            <th>Periodicity</th>
                                            <th>Mandal</th>
                                            <th>District</th>
                                            <th>State</th>
                                            <th>Secretariat</th>
                                        </tr>
                                    </thead>
                                   
                <tbody>
                    {filteredData?.length === 0 ? (
                        <tr>
                             <td className="text-center" colSpan="10" >
                                                    <b style={{ color: "red" }}>Details Not Found</b>
                                                </td>
                        </tr>
                    ) : 
                    (
                        
                        filteredData .map((detail, i) => (
                                    
                                        <tr key={i}>
                                            <td className="text-center fw-semibold sticky-col sticky-sno" >{i + 1}</td>
                                            <td className="text-left fw-semibold sticky-col sticky-mandal" >{detail.indicator_id}</td>
                                            <td className="text-left fw-semibold ">{detail.unit_name}</td>
                                            <td className="text-left fw-semibold ">{detail.cat_description}</td>
                                            <td className="text-left fw-semibold ">{detail.cal_formula}</td>
                                            <td className="text-left fw-semibold ">{detail.periodic_name}</td>
                                            <td className="text-left fw-semibold "> {detail.mandal === "Yes" ? (
                 <img  src="images/check.png"  alt="Yes" style={{ width: "25px" }} />
                ) : (detail.mandal)}</td>
                                            <td className="text-left fw-semibold ">
                                            {detail.district === "Yes" ? (
                 <img  src="images/check.png"  alt="Yes" style={{ width: "25px" }} />
                ) : (detail.district)}</td>
                                            <td className="text-left fw-semibold ">
                                            {detail.state === "Yes" ? (
                 <img  src="images/check.png"  alt="Yes" style={{ width: "25px" }} />
                ) : (detail.state)}</td>
                                            <td className="text-left fw-semibold "> {detail.secretariat === "Yes" ? (
                 <img  src="images/check.png"  alt="Yes" style={{ width: "25px" }} />
                ) : (detail.secretariat)}</td>

                                            {/* <td className="text-center fw-semibold">{detail.unit}</td> */}
                                        </tr>
                        )
                      )
                    )}
                               
                   
                </tbody>
          
             
                                </table>
             
            
                            </div>
                            <div>  </div>
                            <Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={addModal} >
                                <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Modal.Title style={{ margin: "0 auto" }}>Add Indicator/Activity</Modal.Title>
                                    <span role="button" tabIndex={0} style={{ fontSize: "29px", cursor: "pointer", color: "white" }} onClick={handleClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClose(); } }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </span>

                                </Modal.Header>
                                <Modal.Body>
                                    <FormikProvider value={formik} >
                                        <Form onSubmit={formik.handleSubmit}>
                                            <Row className="mt-2 ">
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold"> Indicator Name </label> <span style={{ color: "red" }}> *</span>
                                                    <Field type="text" name="indicator_name"   
                                                   className="form-control" onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} onChange={(e) => { formik.handleChange(e); }} />
                                                  
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold">Unit</label> <span style={{ color: "red" }}> *</span>
                                                    <Field className="mb-3 form-control" component="select" name="unit" controlId="formBasicEmail"  onChange={(e)=>{ 
   formik.handleChange(e)}}>
                    <option value="">--Select--</option>
                    {unitlist}
                  </Field>
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold"> Formula</label> <span style={{ color: "red" }}> *</span>
                                                    <Field type="text" name="formula" className="form-control" 
                                        // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} 
                                       
                                        onChange={(e) => { formik.handleChange(e); }} />
                                                   
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold">Multiplier</label> 
                                                    <Field
                      name="multiplier"
                      // className="form-select"
                      component="select"
                       className="mb-3 form-control"
                       controlId="formBasicEmail"
                      
                      // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      onChange={formik.handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="100">100</option>
                      <option value="1000">1000</option>
                      <option value="10000">10000</option>
                      <option value="100000">100000</option>
                      <option value="1000000">1000000</option>
                      <option value="10000000">10000000</option>

                    </Field>
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold">Divider</label>
                                                    <Field
                      name="divider"
                      // className="form-select"
                      component="select"
                       className="mb-3 form-control"
                       controlId="formBasicEmail"
                      
                      // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                      onChange={formik.handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="100">100</option>
                      <option value="1000">1000</option>
                      <option value="10000">10000</option>
                      <option value="100000">100000</option>
                      <option value="1000000">1000000</option>
                      <option value="10000000">10000000</option>

                    </Field>
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold">Periodicity</label> <span style={{ color: "red" }}> *</span>
                                                    <Field className="mb-3 form-control" component="select" name="periodic_id" onChange={(e)=>{formik.handleChange(e)}}controlId="formBasicEmail">
                    <option value="">--Select--</option>
                    {Periodicitylist}
                  </Field>
                                                </Col>
                                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                                    <label className="mb-1 fw-bold">Entry Type</label> <span style={{ color: "red" }}> *</span>
                                                    <Field
        className="mb-3 form-control"
        component="select"
        name="entry_type"
        controlId="formBasicEmail"
        onChange={(e) => { formik.handleChange(e) }}
       
      >
        <option value="">--Select--</option>
        <option value="mandal">Mandal</option>
        <option value="district">District</option>
        <option value="state">State</option>
        <option value="secretariat">Secretariat</option>
        
      </Field>
                                                </Col>
                                                <Row className="mt-2">
                                                {/* <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mt-2"> */}
                                                <div className="bottom-buttons justify-content-center d-flex  mb-1">
                                                <Button variant="" size="sm" className="save-btn me-4"  onClick={()=>{AddIndicator()}}>
                              Save <FaRegSave className="ms-1 s-icon" />
                            </Button></div>
                                                {/* </Col> */}
            </Row>
            
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                    <Row className="text-start mt-3 mx-1">
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                            <p className="fw-semibold" style={{ color: "red" }}>Note:- Once Submit You Can't Edit</p>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                            </Modal>
            
            
            
            
                        </Container>
           

          </Form>
          </FormikProvider>
      </Container>|


      
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}





